import { Outlet, useLocation, Navigate } from "react-router-dom";
import { BottomTabBar } from "./BottomTabBar";
import { SideNav } from "./SideNav";
import { MobileAccountMenu } from "./MobileAccountMenu";
import { CommandPalette } from "./CommandPalette";
import { useAuthStore } from "@/lib/auth-store";

export function ProtectedLayout() {
  const authed = useAuthStore((s) => s.authed);
  const location = useLocation();
  if (!authed) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      <SideNav />
      <main className="lg:pl-60 pb-20 lg:pb-0 min-h-screen">
        <Outlet />
      </main>
      <BottomTabBar />
      <MobileAccountMenu />
      {/* Inside the router so its commands can navigate; only mounted behind
          auth, since every command targets a protected route. */}
      <CommandPalette />
    </div>
  );
}

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      <Outlet />
    </div>
  );
}
